module.exports = __webpack_public_path__ + "img/airline-mobile.f3a54d5e.png";